/* eslint-disable */
// Written BY HAND -- not generated (see labels.js). Every GraphQL operation the
// cancellations feature sends lives here, so tools/refresh-graphql-schema.js
// validates it against the deployed schema: a renamed field fails
// `npm run graphql:check` instead of the Cancellations page at runtime.
//
// SELECTIONS is an object, not a string, so the validator skips it; the
// batch loader (src/api/cancellationsQueue.js) splices these into aliased
// queries at runtime. The Validate* documents below reproduce exactly the
// shape omsGraphqlBatch.buildBatch() builds, one per selection, so the
// selections are validated too.

export const Q_GET_INVENTORY = /* GraphQL */ `query GetInventory($id: ID!) {
  getInventory(id: $id) { id status listings { items { id marketplaceID status marketplace { id type } } } }
}`;

export const Q_GET_DECISION = /* GraphQL */ `query GetOrderCancellation($id: ID!) { getOrderCancellation(id: $id) { id outcome } }`;

export const M_UPDATE_INVENTORY = /* GraphQL */ `mutation UpdateInventory($input: UpdateInventoryInput!, $condition: ModelInventoryConditionInput) {
  updateInventory(input: $input, condition: $condition) { id status } }`;

export const M_DELETE_LISTING = /* GraphQL */ `mutation DeleteListing($input: DeleteListingInput!, $condition: ModelListingConditionInput) {
  deleteListing(input: $input, condition: $condition) { id } }`;

export const M_UPDATE_LISTING = /* GraphQL */ `mutation UpdateListing($input: UpdateListingInput!, $condition: ModelListingConditionInput) {
  updateListing(input: $input, condition: $condition) { id status } }`;

export const M_CREATE_LISTING = /* GraphQL */ `mutation CreateListing($input: CreateListingInput!) {
  createListing(input: $input) { id status } }`;

// OPT-341: sets a cancelled Shopify listing's product DRAFT at stock 0 (shopifyGateway). No Sellary row is written.
export const M_TAKE_DOWN_SHOPIFY = /* GraphQL */ `mutation TakeDownShopifyListing($listingId: ID!) {
  takeDownShopifyListing(listingId: $listingId) { ok outcome reason } }`;

export const M_CREATE_DECISION = /* GraphQL */ `mutation CreateOrderCancellation($input: CreateOrderCancellationInput!) {
  createOrderCancellation(input: $input) { id outcome resolvedAt resolvedBy } }`;

// Find item's durable link. The override is what the normalizer honours on
// every later projection of the order (omsNormalizer index.js, "A human
// decision is never overwritten"); the OrderMatch update makes the link
// visible immediately instead of at the next projection.
export const M_CREATE_MATCH_OVERRIDE = /* GraphQL */ `mutation CreateOrderMatchOverride($input: CreateOrderMatchOverrideInput!) {
  createOrderMatchOverride(input: $input) { id orderLineId inventoryId } }`;

export const M_UPDATE_ORDER_MATCH = /* GraphQL */ `mutation UpdateOrderMatch($input: UpdateOrderMatchInput!) {
  updateOrderMatch(input: $input) { id orderLineId inventoryId state method } }`;

export const Q_CANCELLED_ORDERS = /* GraphQL */ `query CancelledOrders($owner: String, $status: ModelStringKeyConditionInput, $limit: Int, $nextToken: String) {
  ordersByOwnerAndStatus(owner: $owner, status: $status, limit: $limit, nextToken: $nextToken) {
    items { id owner channel channelAccountRef externalOrderId status channelNativeStatus sourceUpdatedAt placedAt }
    nextToken
  }
}`;

export const Q_ACCOUNTS = /* GraphQL */ `
  query AccountsByOwner($owner: String, $limit: Int, $nextToken: String) {
    marketplaceByOwner(owner: $owner, limit: $limit, nextToken: $nextToken) {
      items { id username type owner }
      nextToken
    }
  }
`;

export const Q_FIND_ITEM = /* GraphQL */ `
  query FindItemBySKU($owner: String, $sku: ModelStringKeyConditionInput) {
    lookupByOwnerAndSKU(owner: $owner, sku: $sku) {
      items {
        id sku title location status images owner cancelResolvedAt
        listings { items { id marketplaceID status url marketplace { id type username } } }
      }
      nextToken
    }
  }
`;

export const SELECTIONS = {
  LINE_FIELDS: `id orderId sku titleSnapshot quantity salePriceCents removed`,
  MATCH_FIELDS: `id orderLineId inventoryId state method`,
  INVENTORY_FIELDS: `id sku title location status images owner cancelResolvedAt
  listings { items { id marketplaceID status url marketplace { id type username } } }`,
  DECISION_FIELDS: `id outcome note soldElsewhereChannel resolvedAt resolvedBy inventoryId sku`,
  EVENT_FIELDS: `toStatus observedAt`,
};

export const ValidateBatchLines = /* GraphQL */ `query ValidateBatchLines($v0: ID) {
  a0: orderLinesByOrder(orderId: $v0, limit: 200) { items { id orderId sku titleSnapshot quantity salePriceCents removed } nextToken }
}`;

export const ValidateBatchMatches = /* GraphQL */ `query ValidateBatchMatches($v0: ID) {
  a0: orderMatchesByLine(orderLineId: $v0, limit: 200) { items { id orderLineId inventoryId state method } nextToken }
}`;

export const ValidateBatchEvents = /* GraphQL */ `query ValidateBatchEvents($v0: ID) {
  a0: orderStatusEventsByOrder(orderId: $v0, limit: 200) { items { toStatus observedAt } nextToken }
}`;

export const ValidateBatchDecisions = /* GraphQL */ `query ValidateBatchDecisions($v0: ID!) {
  a0: getOrderCancellation(id: $v0) { id outcome note soldElsewhereChannel resolvedAt resolvedBy inventoryId sku }
}`;

export const ValidateBatchInventory = /* GraphQL */ `query ValidateBatchInventory($v0: ID!) {
  a0: getInventory(id: $v0) { id sku title location status images owner cancelResolvedAt
  listings { items { id marketplaceID status url marketplace { id type username } } } }
}`;
